// eslint-disable-next-line
export default Date.prototype.useAddDateDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};
